module.exports = require('./helpers/bundle-url').getBundleURL('3u1yT') + "logo.c51670a8.svg";